import { Stack } from '@myphx-engineering/phx-design-system';

import { useFlags } from '../../hooks/use-flags';

export const CobrandedLogo = () => {
    const { cobrandingEnabled } = useFlags();

    // TODO: remove redundant code. i don't want to store partner logo in myphx-lib
    // but also null check doesn't work well with this component. going to follow
    // up and not do this
    if (!cobrandingEnabled) {
        return (
            // oxlint-disable-next-line jsx-a11y/alt-text -- tracked in docs/oxlint-violations.md
            <img src="/static/libraries/myphx-lib/logos/prescryptive-logo-white-text.svg" />
        );
    }

    return (
        <Stack ml="auto" mr="auto">
            {/* oxlint-disable-next-line jsx-a11y/alt-text -- tracked in docs/oxlint-violations.md */}
            <img src="/static/img/partner-alternate-logo.png" width="85%" />
        </Stack>
    );
};
